import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { CROP_STATUSES } from '../../challenges';

const grammarTriageItemSchema = z.object({
  linkId: z.number().int(),
  pointId: z.number().int(),
  pointTitle: z.string(),
  machinePattern: z.string().nullable(),
  clipId: z.number().int(),
  collectionId: z.number().int().nullable(),
  collectionTitle: z.string().nullable(),
  subtitleEntryIndices: z.string().nullable(),
  transcript: z.string().nullable(),
  targetText: z.string(),
  durationMs: z.number().int(),
  startMs: z.number().int().nullable(),
  endMs: z.number().int().nullable(),
  baseLocalPath: z.string().nullable(),
  verticalLocalPath: z.string().nullable(),
  basePath: z.string().nullable(),
  verticalPath: z.string().nullable(),
  cropStatus: z.enum(CROP_STATUSES).nullable(),
});

const listGrammarTriageQueueV1DataSchema = z.object({
  items: z.array(grammarTriageItemSchema),
  nextCursor: z.string().nullable(),
});

type ListGrammarTriageQueueV1DataType = z.infer<typeof listGrammarTriageQueueV1DataSchema>;

export type IListGrammarTriageQueueV1Response = IAPI<ListGrammarTriageQueueV1DataType>;

export const listGrammarTriageQueueV1ResponseSchema: z.ZodSchema<IListGrammarTriageQueueV1Response> =
  createApiResponseSchema(
    listGrammarTriageQueueV1DataSchema,
  ) as z.ZodSchema<IListGrammarTriageQueueV1Response>;
export type IGrammarTriageItem = z.infer<typeof grammarTriageItemSchema>;
